const getModuleState = (state) => state.cinemas;

export const getAllCinemas = (state) => getModuleState(state).allCinemas;
export const getCinemaById = (state) => getModuleState(state).cinemaById;
export const getCinemaBySlug = (state) => getModuleState(state).cinemaBySlug;
export const getCinemasWithDolby = (state) => getModuleState(state).cinemasWithDolby;
export const getCinemaGalicinos = (state) => getModuleState(state).cinemaGalicinos;